import './global.js'
import Parse from 'parse';
import React from 'react';
//import SinglePost from "./singlepost.jsx";
import { Route, Link} from "react-router-dom";
import Leftsidebar from "./Leftsidebar.jsx";
import $ from "jquery";
import SinglePost from "./gridsinglepost.jsx";
function time_ago(time) {

  switch (typeof time) {
    case 'number':
      break;
    case 'string':
      time = +new Date(time);
      break;
    case 'object':
      if (time.constructor === Date) time = time.getTime();
      break;
    default:
      time = +new Date();
  }
  var time_formats = [
    [60, 'seconds', 1], // 60
    [120, '1 minute ago', '1 minute from now'], // 60*2
    [3600, 'minutes', 60], // 60*60, 60
    [7200, '1 hour ago', '1 hour from now'], // 60*60*2
    [86400, 'hours', 3600], // 60*60*24, 60*60
    [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
    [604800, 'days', 86400], // 60*60*24*7, 60*60*24
    [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
    [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
    [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
    [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
    [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
    [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
    [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
    [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
  ];
  var seconds = (+new Date() - time) / 1000,
    token = 'ago',
    list_choice = 1;

  if (seconds == 0) {
    return 'Just now'
  }
  if (seconds < 0) {
    seconds = Math.abs(seconds);
    token = 'from now';
    list_choice = 2;
  }
  var i = 0,
    format;
  while (format = time_formats[i++])
    if (seconds < format[0]) {
      if (typeof format[2] == 'string')
        return format[list_choice];
      else
        return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
    }
  return time;
}


class GridStream extends React.Component {

    constructor(props) {
        super(props);
        Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw"); 
        Parse.serverURL = "https://parse.joelskitchen.com/parse";
        //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";

        var now = new Date();

        this.state = {
            posts: {},
            users: {},
            created_at: now.getTime(),
            hideUntilId: '',
        };
        this.queryForPostData();
        this.homeFetch = this.homeFetch.bind(this); 
        const storestreamid = localStorage.getItem('storestreamid');
        this.state.hideUntilId=storestreamid;
    }
    homeFetch(event){
              this.queryForPostData();
    }
   shouldHide = (id) => {

    let allpostids = [];
    for (var i = 0; i < this.state.posts.length; i++)
    {
       var posts = this.state.posts[i];
       allpostids.push(posts.id); 
    }
    const allIds =allpostids; //['kN23G3RilJ','JZTWnFoMr3', 'SyupXzNACc']; // All ids in order
    const hideIndex = allIds.indexOf(this.state.hideUntilId);
    const currentIndex = allIds.indexOf(id);
    return currentIndex < hideIndex;
  };
    getSuggestedUsers() {
      var query = new Parse.Query('User');
      query.equalTo('isSuggested', 1);
      query.include("username");
      query.descending('_created_at');
      var self = this;
       query.find().then(function(result){
            if(result){
               self.setState({users: result});
            } else {
                console.log("No user found");
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });

    }

    queryForPostData() {  
    const storestreamtabValue = localStorage.getItem('storestreamtabValue');
    const storestreampagepath = localStorage.getItem('storestreampagepath');
    console.log(storestreamtabValue+'storestreamtabValue')
    console.log(storestreampagepath+'storestreampagepath')
    if(storestreamtabValue==='saved' && storestreampagepath==='my-profile')
    { 
        let currentUser = Parse.User.current();
        const Save = Parse.Object.extend('Save');
        const query = new Parse.Query(Save);
        query.equalTo("fromUser", "_User$"+currentUser.id);
        query.exists('photo');
        query.include('photo');
        query.include("image");
        query.doesNotExist("isChallenge");
        query.include("photo.user");
        query.include("photo.image");
        query.include("photo.thumbnail");
        query.include("photo.likeCountNew");
        query.include("photo.saveCount");
        query.include("photo.commentcount");
        query.include("photo._created_at");
        query.include("photo.createdAt");
        query.descending("_created_at");
        //query.exists("photo.user");
        var self = this;    
        query.find().then(function(results){
          let saveRecord = [];
            if(results)
            { 
              for (var i = 0; i <results.length; i++)
            {
              var post = results[i];
              if(post.get('photo') && post.get('photo').id)
              {
                 saveRecord.push( post.get('photo'));
              }
             }              
            }
             self.setState({posts: saveRecord});
          })
    }
    if(storestreamtabValue==='posts' && storestreampagepath==='my-profile')
    { 
        let currentUser = Parse.User.current();
        var query = new Parse.Query('Photo');
        
        query.include("user");
        query.include("image");
        query.include("thumbnail");
        query.include("likeCountNew");
        query.include("saveCount");
        query.include("commentcount");
        query.include("_created_at");
        query.include("createdAt");
        query.exists("user");
        query.exists("image");//added
        query.exists("thumbnail");//added
        query.doesNotExist("isChallenge");//added
        query.descending("createdAt");
        query.limit(99999999999999999999999999);
        query.equalTo("user", currentUser);
        var self = this;
        query.find().then(function(result){
            if(result){
                self.setState({posts: result});
            }
          })
        
    }

    if(storestreamtabValue==='recipes' && storestreampagepath==='my-profile')
    { 
         let currentUser = Parse.User.current();
         var self = this;
         var getRecipequery = new Parse.Query('Photo');  
             // getRecipequery.exists('recipeV2');
              getRecipequery.exists('isRecipe');
              getRecipequery.equalTo('user',currentUser);
              getRecipequery.doesNotExist("isChallenge");
              getRecipequery.descending("_created_at");
              getRecipequery.find().then(function(recipe){
              if(recipe)
              {         
                  self.setState({posts: recipe});
              }
             })
    }
    if(storestreamtabValue==='posts' && storestreampagepath==='user')
    { console.log('posts user');
        let currentUser = Parse.User.current();
        var query = new Parse.Query('Photo');
        const streampagepathuser = localStorage.getItem('streampagepathuser');
        query.include("user");
        query.exists("image");//added
        query.exists("thumbnail");//added
        query.include("image");
        query.include("thumbnail");
        query.include("likeCountNew");
        query.include("saveCount");
        query.include("commentcount");
        query.include("_created_at");
        query.include("createdAt");
        query.exists("user");
        
        query.doesNotExist("isChallenge");//added
        query.descending("createdAt");
        query.limit(99999999999999999999999999);
        //query.equalTo("user", currentUser);
        query.equalTo("user", "_User$"+streampagepathuser);
        var self = this;
        query.find().then(function(result){
            
            if(result.length!==undefined)
                {
                self.setState({posts: result});
              }
           
          })        
    }

    if(storestreamtabValue==='recipes' && storestreampagepath==='user')
    {

         let currentUser = Parse.User.current();
         const streampagepathuser = localStorage.getItem('streampagepathuser');
         var self = this;
         var getRecipequery = new Parse.Query('Photo');  
         // getRecipequery.exists('recipeV2');
          getRecipequery.exists('isRecipe');
          getRecipequery.include("user");
          getRecipequery.equalTo("user", "_User$"+streampagepathuser);
          getRecipequery.doesNotExist("isChallenge");
          getRecipequery.descending("_created_at");
          getRecipequery.find().then(function(recipe){
          if(recipe)
          {   
              self.setState({posts: recipe});
          }
         })

    }
    if(storestreamtabValue==='saved' && storestreampagepath==='user')
    {   
        const streampagepathuser = localStorage.getItem('streampagepathuser');
        let currentUser = Parse.User.current();
        const Save = Parse.Object.extend('Save');
        const query = new Parse.Query(Save);
        query.equalTo("fromUser", "_User$"+streampagepathuser);
        query.exists('photo');
        query.include('photo');
        query.include("image");
        query.doesNotExist("isChallenge");
        query.include("photo.user");
        query.include("photo.image");
        query.include("photo.thumbnail");
        query.include("photo.likeCountNew");
        query.include("photo.saveCount");
        query.include("photo.commentcount");
        query.include("photo._created_at");
        query.include("photo.createdAt");
        query.descending("_created_at");
        //query.exists("photo.user"); 
        var self = this;    
        query.find().then(function(results){
          let saveRecord = [];
            if(results)
            { 
              for (var i = 0; i <results.length; i++)
            {
              var post = results[i];
              if(post.get('photo') && post.get('photo').id)
              {
                 saveRecord.push( post.get('photo'));
              }
             }              
            }
             self.setState({posts: saveRecord});
          })
    }

    if(storestreamtabValue==='explore' && storestreampagepath==='explore')
    { 
   
        var query = new Parse.Query('Photo');
        query.include("image");
        query.include("thumbnail");
        query.include("_created_at");
        query.include("createdAt");
        query.doesNotExist("isChallenge");
       /* query.select("isChallengeWinner");
        query.select("isChallengeEntry");
        query.select("image");
        query.select("thumbnail");
        query.select("isRecipe");*/
        query.exists("user");
        query.include("user");
        query.descending("createdAt");
        var self = this;   
         query.find().then(function(result){
          if(result)
          {  
              self.setState({posts: result});
          }
         })
    }

    if(storestreampagepath==='challengedetail')
    {
        var query = new Parse.Query('Photo');
        query.equalTo('isChallengeEntry', "1");
        query.equalTo('challenge', "Photo$"+storestreamtabValue);
        /*query.select("isChallengeWinner");
        query.select("isChallengeEntry");
        query.select("hideEntry");*/
        /*query.select("image");
        query.select("thumbnail");
        query.select("isRecipe");*/
        query.exists("user");  
        query.include("user");
        query.include("image");
        query.include("thumbnail");      
              
        query.descending("createdAt");
        var self = this;   
         query.find().then(function(result){
          if(result)
          {  
            self.setState({posts: result});
          }
         })
    }
if(storestreampagepath==='searchresult')
    {
      var query = new Parse.Query('User');
      query.equalTo('isSuggested', 1);
      query.descending('_created_at');
      let SearchTitle  =storestreamtabValue;
     
      var self = this;
      query.find().then(function(result){
            if(result){
              let userSuggdataresult1 = [];
              if(result.length>0)
              {               
                   for (var i = 0; i < result.length; i++)
                   {
                     var user = result[i];
                     userSuggdataresult1[i]='_User$'+user.id;
                   } 
                    var queryphoto = new Parse.Query('Photo');
                    queryphoto.include("user");
                    queryphoto.limit(99999999999);
                    let jointuser=userSuggdataresult1;
                    queryphoto.descending("createdAt");
                      if (SearchTitle) {
                        queryphoto.contains('caption', SearchTitle);
                      }
                    queryphoto.find().then(function(photo){
                        self.setState({ posts: photo});
                    });
              }
            } else {
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });
    }

if(storestreampagepath==='search' && storestreamtabValue==='')
    {
      var query = new Parse.Query('User');
      query.equalTo('isSuggested', 1);
      query.descending('_created_at');
      query.limit(4);
      
      var self = this;
      query.find().then(function(result){
            if(result){
              let userSuggdataresult1 = [];
              if(result.length>0)
              {               
                   for (var i = 0; i < result.length; i++)
                   {
                     var user = result[i];
                     userSuggdataresult1[i]='_User$'+user.id;
                   } 
                    var queryphoto = new Parse.Query('Photo');
                    queryphoto.include("user");
                    queryphoto.limit(4);
                    let jointuser=userSuggdataresult1;
                    queryphoto.descending("createdAt");
                    
                    queryphoto.find().then(function(photo){
                        self.setState({ posts: photo});
                    });
              }
            } else {
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });


    }
  if(storestreampagepath==='search' && storestreamtabValue!=='')
    { 
      var query = new Parse.Query('User');
      query.equalTo('isSuggested', 1);
      query.descending('_created_at');
      query.limit(10);
      let SearchTitle  =storestreamtabValue;
      var self = this;
      query.find().then(function(result){
            if(result){
              let userSuggdataresult1 = [];
              if(result.length>0)
              {               
                   for (var i = 0; i < result.length; i++)
                   {
                     var user = result[i];
                     userSuggdataresult1[i]='_User$'+user.id;
                   } 
                    var queryphoto = new Parse.Query('Photo');
                    queryphoto.include("user");
                    queryphoto.limit(4);
                    let jointuser=userSuggdataresult1;
                    queryphoto.descending("createdAt");
                    if (SearchTitle) {
                        queryphoto.contains('caption', SearchTitle);
                    } 
                     
                    queryphoto.find().then(function(photo){
                        self.setState({ posts: photo});
                    });
              }
            } else {
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });
    }
    }
    
    renderPosts()
    {
        let buffer = [];
        var self = this;

        if (this.state.posts)
        { 
            for (var i = 0; i < this.state.posts.length; i++)
            {
                var post = this.state.posts[i];
                buffer.push(<div  style={{ display: self.shouldHide(post.id) ? 'none' : 'block' }}  id={post.id} className='card_box b' key={69*i}>
                    <SinglePost postData={post}/>
                </div>);                 
            } 
        } 
        return ( <div className='list_group streampage'>

                {buffer}
                 <input type="hidden" id="home_id" name="home_id" />
                </div>
        );

    }

    render() {

    var likesWord = "likes";
    var savesWord = "saves";
    var commentsWord = "comments";

    if (this.state.likeCount == 1) likesWord = "like";
    if (this.state.saveCount == 1) savesWord = "save";
    if (this.state.commentCount == 1) commentsWord = "comment";
   
    return (
      
      <section className='post_list'> 
        <div className='container'>
          <div className='inner'>
            <nav className='sidebar'>
              <Leftsidebar/>
            </nav>
            <main className='listing sticky_app_btn'>
                
                <div className='get-app cta_btn'>
                  <div className='secondary-btn btn-wrp sml-btn'>
                    <a href='javascript:void(0);' type="button" data-toggle="modal" data-target="#kitchenQrModal" title='Get app'>Get app</a>
                  </div>
                </div>
              {this.renderPosts()}
            </main>
          </div>
        </div>
      
      </section>      
    );
  }
}

export default GridStream;



// WEBPACK FOOTER //
// ./src/gridstream.jsx